<template>
  <div id="inform">
    <!-- 顶部 -->
    <nav>
      <span>{{ $fanyi("全部通知") }}</span>
      <div class="choiseStatus">
        <div class="option" @click="setradio(2)" :class="{ active: radio == 2 }">

          {{ $fanyi("已读") }}
        </div>
        <div class="option" @click="setradio(1)" :class="{ active: radio == 1 }">

          {{ $fanyi("未读") }}
        </div>
      </div>
    </nav>
    <div class="content" v-loading="loading">
      <!-- 全选 -->
      <div class="operation">
        <el-checkbox v-model="checked" @change="allChiose">{{
          $fanyi("全选")
        }}</el-checkbox>
        <button class="deleteBtn" @click="deleteNotification">
          <img src="@/assets/newassets/cart/delete2.svg" alt="">{{ $fanyi("删除") }}
        </button>
      </div>
      <!-- 通知列表 -->
      <div class="Notification" v-for="(inFoItem, inFoIndex) in informlist"
        :class="{ read: inFoItem.statusName == '已读' }" :key="inFoIndex">
        <div class="left">
          <el-checkbox v-model="inFoItem.checked" @change="inFoItemChiose"></el-checkbox>

          <p class="NotificationTitle" @click="openDetail(inFoItem)">
            {{ inFoItem.title }}
          </p>
        </div>
        <div class="right">
          <div class="circle"></div>
          <div class="time">{{ inFoItem.created_at }}</div>
        </div>
      </div>
      <div class="Nodata" v-if="Nodata">

        <div class="NodataImg">
          <img src="../../../../assets/defaulticon/inform.svg" alt="">
        </div>

        <div class="NodataText">

          {{ $fanyi('暂无通知消息') }}
        </div>

      </div>
    </div>

    <Dialog ref="dialog" :config="config" />
    <InFormDetail @noticeReadNotice="noticeReadNotice" ref="InFormDetail" />
  </div>
</template>
<script>
import Dialog from "../../../../components/public/Dialog";
import InFormDetail from "./InFormDetail";
export default {
  data() {
    return {
      loading: false,
      radio: "", // 	  1-未读, 2-已读


      checked: false, // 全选
      readItem: {},
      informlist: [],
      Nodata: false,
      config: {
        top: "20vh",
        width: "500px",
        txtcenter: true,
        title: this.$fanyi("提示"),
        btnTxt: [this.$fanyi("删除"), this.$fanyi("取消")],
      },
    };
  },
  components: { Dialog, InFormDetail },
  computed: {},
  created() {
    this.getList();
  },
  methods: {
    // 获取列表
    async getList() {
      this.loading = true
      const res = await this.$api.noticeClientNoticeList({ hasRead: this.radio });
      this.loading = false
      if (res.code != 0) {
        this.$message.error(res.msg);
        this.Nodata = true
        return
      }
      let unreadlist = []// 未读
      let readlist = [] // 已读
      res.data.data.forEach((item, index) => {
        if (item.statusName == '未读') {
          unreadlist.push(item)
        } else {
          readlist.push(item)
        }
      })
      this.informlist = [...unreadlist, ...readlist]
      if (!res.data.data || res.data.data.length == 0) {
        this.Nodata = true
      } else {
        this.Nodata = false
      }

    },
    // 删除通知
    deleteNotification() {
      if (this.informlist.every((item) => !item.checked)) {

        this.$message({
          message: this.$fanyi('请先选择要删除的通知'),
          type: 'warning'
        })
        return
      }
      this.$refs.dialog.open(
        this.$fanyi("是否确认删除选中的通知"),
        (cancel) => {
          cancel()
          this.deleteInFo();
        },
        () => { }
      );
    },
    //删除选中通知
    deleteInFo() {
      let deleteArr = [];
      this.informlist.forEach((item) => {
        if (item.checked == true) {
          deleteArr.push(item.id);
        }
      });
      this.$api.noticeBatchDelete({ ids: deleteArr }).then((res) => {
        if (res.code != 0) {
          this.$message.error(res.msg);
          return
        }
        this.$message.success(this.$fanyi("操作成功"));
        this.informlis = []
        this.getList();
      });
    },    // 打开详情弹窗
    openDetail(item) {
      this.readItem = item;
      this.$refs.InFormDetail.open(this.readItem);
    },
    // 消息已读
    noticeReadNotice() {
      if (this.readItem.statusName !== '已读') {
        // 调用接口
        this.$api.noticeReadNotice({ id: this.readItem.id }).then((res) => {
          this.informlist.forEach((item) => {
            if (item.id == this.readItem.id) {
              item.statusName = '已读'
            }
          });
        });
        // 更新
        this.$forceUpdate()
      }


    },
    // 设置列表状态筛选
    setradio(val) {
      if (this.radio == val) {
        this.radio = "";
      } else {
        this.radio = val;
      }
      this.getList();
    },
    // 全选
    allChiose() {
      this.informlist.forEach((item) => {
        item.checked = this.checked;
      });
    },
    inFoItemChiose() {
      this.checked = this.informlist.every((item) => item.checked)
    }
  },
};
</script>
<style lang='scss' scoped>
@import "../../../../css/mixin.scss";



#inform {
  width: 1060px;
  min-height: 229px;
  background: #FFFFFF;
  border-radius: 20px;

  padding: 30px;

  nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 28px;

    span {
      font-weight: 400;
      font-size: 18px;
      color: #121212;
    }

    .choiseStatus {
      display: flex;
      align-items: center;
      user-select: none;

      .option {
        font-weight: 500;
        font-size: 14px;
        color: #121212;
        margin-left: 21px;

        &:hover {
          cursor: pointer;
        }

        &.active {
          font-weight: 500;
          font-size: 14px;
          color: #D12A1D;
        }


      }
    }
  }

  .content {
    .operation {

      width: 1000px;
      min-height: 50px;
      padding: 0 20px;
      background: #FAFAFA;
      border-radius: 10px;
      display: flex;
      align-items: center;
      margin-top: 20px;
      justify-content: space-between;
      align-items: center;

      /deep/.el-checkbox__input {
        height: 20px;
        margin-right: 10px;


        .el-checkbox__inner {
          width: 20px;
          height: 20px;
          border-radius: 6px;
          border: 1px solid #D4D4D4;

          &::after {
            position: absolute;
            top: 45%;
            width: 4px;
            height: 9px;
            left: 50%;
            transform: translate(-50%, -50%) rotate(45deg);
          }
        }
      }

      /deep/ .el-checkbox__input.is-checked {
        .el-checkbox__inner {
          background-color: #D12A1D;
          border-color: #D12A1D;
        }
      }

      .deleteBtn {
        display: flex;
        align-items: center;

        &:hover {
          cursor: pointer;
        }

        img {
          width: 16px;
          height: 16px;
          margin-right: 12px;

        }

        font-weight: 500;
        font-size: 14px;
        color: #D12A1D;
      }
    }

    .Nodata {
      display: flex;
      align-items: center;
      height: 360px;
      padding-top: 58px;
      flex-direction: column;

      .NodataImg {
        width: 160px;
        height: 160px;

        img {
          width: 100%;
          height: 100%;
        }


        margin-bottom: 30px;
      }

      .NodataText {
        font-weight: normal;
        font-size: 24px;
        color: #121212;
        line-height: 20px;
      }

    }

    .Notification {
      height: 60px;
      border-bottom: #F5F5F5 solid 1px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;

      .left {

        display: flex;
        align-items: center;

        /deep/.el-checkbox__input {
          height: 20px;
          margin-right: 20px;


          .el-checkbox__inner {
            width: 20px;
            height: 20px;
            border-radius: 6px;
            border: 1px solid #D4D4D4;

            &::after {
              position: absolute;
              top: 45%;
              width: 4px;
              height: 9px;
              left: 50%;
              transform: translate(-50%, -50%) rotate(45deg);
            }
          }
        }

        /deep/ .el-checkbox__input.is-checked {
          .el-checkbox__inner {
            background-color: #D12A1D;
            border-color: #D12A1D;
          }
        }

        .NotificationTitle {
          width: 607px;

          font-family: Roboto;
          font-weight: 400;
          font-size: 14px;
          color: #121212;

          &:hover {
            cursor: pointer;
          }

          // 溢出隐藏显示省略号

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: 400;
          font-size: 14px;
          color: #121212;

          &:hover {
            color: #D12A1D;

            text-decoration-line: underline;
          }

        }
      }

      .right {
        display: flex;
        align-items: center;

        .circle {
          width: 8px;
          height: 8px;
          background: #D12A1D;
          border-radius: 50%;
          margin-right: 10px;
        }

        .time {
          font-weight: 300;
          font-size: 14px;
          color: #121212;
        }
      }



      &.read {
        color: #999999;


        .left {
          .NotificationTitle {
            color: #999999;

            &:hover {

              text-decoration: underline;
              color: #999999;
            }
          }
        }

        .right {
          .circle {
            background: #DFDFDF;
          }

          .time {
            font-weight: 300;
            font-size: 14px;
            color: #999999;
          }

        }

      }

    }
  }

}
</style>